import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import HeaderFooter from "../components/headerFooter";
require("dayjs/locale/th");
dayjs.locale("th");

const columns = [
  { id: "requester", label: "ผู้จอง", align: "center", width: "280px" },
  {
    id: "dateTimeStart",
    label: "วัน - เวลา ขาไป",
    align: "center",
    width: "280px",
  },
  {
    id: "dateTimeEnd",
    label: "วัน - เวลา ขากลับ",
    align: "center",
    width: "280px",
  },
  { id: "place", label: "ต้นทาง - ปลายทาง", align: "center", width: "200px" },
  { id: "typeFlight", label: "ประเภท", align: "center", width: "100px" },
];

const DriverBooking = (props) => {
  const [listBookingNotSuccess, setListBookingNotSuccess] = useState([]);
  const [listBookingIsSuccess, setListBookingIsSuccess] = useState([]);

  useEffect(() => {
    const formatDate = (date) => dayjs(date).format("D MMM YYYY");
    const formatTime = (time) => dayjs(time).format("HH.mm") + " น.";

    let listBooking = props.booking;

    if (listBooking != null) {
      const currentDate = new Date().toISOString();
      const listA = [];
      const listB = [];

      listBooking.map((booking) => {
        const formattedBooking = {
          bookingId: booking.idDriverBooking,
          nameLabel: "ผู้จอง ",
          name: booking.nameUser,
          email: booking.user.email,
          phone: booking.user.telephoneMobile,
          startDateLabel: "วันที่ขาไป ",
          startDate: (booking.startDate && booking.endDate) && `${formatDate(booking.startDate)} - ${formatDate(
            booking.endDate
          )}`,
          startTime: (booking.startTime && booking.endTime) && `${booking.startTime}น. - ${booking.endTime}น.`,
          returnDateLabel: "วันที่ขากลับ ",
          returnDate: (booking.startDateReturn && booking.endDateReturn) && `${formatDate(booking.startDateReturn)} - ${formatDate(
            booking.endDateReturn
          )}`,
          returnTime: (booking.startTimeReturn && booking.endTimeReturn) && `${booking.startTimeReturn}น.-${booking.endTimeReturn}น.`,
          fromPlace: booking.namePlaceFrom,
          toPlace: booking.namePlaceTo,
          typeFlight: booking.twoWay ? "ไป-กลับ" : "เที่ยวเดียว",
        };

        if (booking.startDate < currentDate) {
          listA.push(formattedBooking);
        } else {
          listB.push(formattedBooking);
        }
      });

      setListBookingIsSuccess(listA);
      setListBookingNotSuccess(listB);
    }
  }, []);

  return (
    listBookingIsSuccess &&
    listBookingNotSuccess && (
      <HeaderFooter
        columns={columns}
        listBookingIsSuccess={listBookingIsSuccess}
        listBookingNotSuccess={listBookingNotSuccess}
        showHistory={props.showHistory}
        typeOfBooking={props.typeOfBooking}
        onClickCardHandler={props.onClickCardHandler}
      />
    )
  );
};

export default DriverBooking;
